import { render, staticRenderFns } from "./MyObjectsPage.vue?vue&type=template&id=358390fe&scoped=true&lang=pug"
import script from "./MyObjectsPage.vue?vue&type=script&lang=js"
export * from "./MyObjectsPage.vue?vue&type=script&lang=js"
import style0 from "./MyObjectsPage.vue?vue&type=style&index=0&id=358390fe&lang=scss&scoped=true"
import style1 from "./MyObjectsPage.vue?vue&type=style&index=1&id=358390fe&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358390fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('358390fe')) {
      api.createRecord('358390fe', component.options)
    } else {
      api.reload('358390fe', component.options)
    }
    module.hot.accept("./MyObjectsPage.vue?vue&type=template&id=358390fe&scoped=true&lang=pug", function () {
      api.rerender('358390fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/my_objects/MyObjectsPage.vue"
export default component.exports